export const environment = {
  production: true,
  dbConfig: {
    type: "DB_TYPE" in process.env ? process.env.DB_TYPE : 'mysql',
    host: "DB_HOST" in process.env ? process.env.DB_HOST : 'localhost',
    port: "DB_PORT" in process.env ? process.env.DB_PORT : 3306,
    username: "DB_USER" in process.env ? process.env.DB_USER : 'gpon',
    password: "DB_PASSWORD" in process.env ? process.env.DB_PASSWORD : 'gpon',
    database: "DB_NAME" in process.env ? process.env.DB_NAME : 'gpon'
  }
}
